exports = module.exports = require("../../../../build/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".com-video-player{position:absolute;top:0;left:0;width:100%;height:100%;background-color:#303133}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/sass-loader/dist/cjs.js!../src/component/video-player/scss/index.scss
// module id = 651
// module chunks = 0 1 2 3